import { gql } from '@apollo/client';

export const GetLocationsQuery = gql`
    query GetLocations($regionId: ID, $lapId: ID) {
        getLocations(regionId: $regionId, lapId: $lapId) {
            id
            name
        }
    }
`;
